var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_16048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 14.6666H7.99967C4.85701 14.6666 3.28567 14.6666 2.30901 13.6899C1.33301 12.7146 1.33301 11.1426 1.33301 7.99992C1.33301 4.85725 1.33301 3.28592 2.30901 2.30925C3.28634 1.33325 4.85701 1.33325 7.99967 1.33325C11.1423 1.33325 12.7137 1.33325 13.6897 2.30925C14.339 2.95859 14.5563 3.87125 14.6297 5.33325M9.99967 14.6666C11.2374 14.6666 12.4243 14.1749 13.2995 13.2998C14.1747 12.4246 14.6663 11.2376 14.6663 9.99992M9.99967 14.6666C9.99967 13.4259 9.99967 12.8053 10.163 12.3033C10.3256 11.803 10.6042 11.3483 10.9761 10.9764C11.3481 10.6044 11.8028 10.3258 12.303 10.1633C12.805 9.99992 13.4257 9.99992 14.6663 9.99992M14.6663 9.99992V7.99992",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7H9M4 10H6.60684",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_16048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.86dba184ecd06a9b11f220db2c2be809.svg";
export { ForwardRef as ReactComponent };